import {IServiceMode} from 'Maintain/models/IServiceMode';

export function convertServiceModeToClient(serviceMode: IServiceMode): IServiceMode {
  return {
    ...serviceMode
  };
}
